import { DEFAULT_PURCHASE_CYCLE, DEFAULT_SALE_PURCHASE_CYCLE } from '../utils/consts';
export const resolveCurrentDefaultCycle = _ref => {
  let {
    hasSale,
    alwaysDefaultsToYearly
  } = _ref;
  return hasSale && !alwaysDefaultsToYearly ? DEFAULT_SALE_PURCHASE_CYCLE : DEFAULT_PURCHASE_CYCLE;
};
//# sourceMappingURL=resolveCurrentDefaultCycle.js.map